import { createFileRoute, notFound } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { getCatalog } from '~/entities/catalog/api';

/**
 * Dev-only UI kit. Vite replaces `import.meta.env.DEV` with a literal, so in a production build the
 * lazy import below is a dead branch and the kit's code never makes it into the bundle.
 */
const UiKitPage = import.meta.env.DEV
  ? lazy(async () => import('~/pages/ui-kit').then((module) => ({ default: module.UiKitPage })))
  : () => null;

export const Route = createFileRoute('/ui-kit')({
  beforeLoad: () => {
    if (!import.meta.env.DEV) {
      // TanStack Router expects its notFound() result to be thrown as-is.
      // eslint-disable-next-line @typescript-eslint/no-throw-literal
      throw notFound();
    }
  },
  loader: async () => getCatalog(),
  component: UiKitRoute,
});

function UiKitRoute() {
  const catalog = Route.useLoaderData();

  return (
    <Suspense fallback={null}>
      <UiKitPage catalog={catalog} />
    </Suspense>
  );
}
